import React from 'react';
import Tag from './GardenStyleTag';

const GardenStyle = ({ gardenType, onSelect, isSelected }) => {

    const gardenStyles = {
        "In Ground Garden" : "./inGroundGardenTest1.png",
        "Raised Bed Garden": "./raisedGardenBedTest.png",
        "Container Garden": "./containerGardenTest.png",
        "Indoor Garden": "./greenhouseTest4.png",
        "Vertical Garden": "./verticalGardenTest1.png",
        "Hydroponic Garden": "./plant.png"
    };

    const gardenDescriptions = {
        "In Ground Garden": "A traditional garden planted directly into the soil—great for larger spaces and long-term growing.",
        "Raised Bed Garden": "Gardening in elevated beds for better soil control, drainage, and easier maintenance.",
        "Container Garden": "Flexible and mobile gardening using pots or planters—perfect for patios, balconies, and small spaces.",
        "Indoor Garden": "Grow herbs, greens, and small plants inside your home with controlled light and temperature.",
        "Vertical Garden": "Maximize limited space by growing plants upward on walls, trellises, or stacked systems.",
        "Hydroponic Garden": "A soil-free method using nutrient-rich water—efficient, clean, and great for indoor setups."
    };

    const gardenTags = {
        "In Ground Garden": ["Beginner", "Large ", "$", "success", "medium", "subtle", "info", "medium", "subtle", "success", "medium", "subtle"],
        "Raised Bed Garden": ["Beginner", "Medium ", "$$", "success", "medium", "subtle", "accent", "medium", "subtle", "warning", "medium", "subtle"],
        "Container Garden": ["Beginner", "Small", "$", "success", "medium", "subtle", "primary", "medium", "subtle", "success", "medium", "subtle"],
        "Indoor Garden": ["Intermediate", "Small", "$$", "warning", "medium", "subtle", "primary", "medium", "subtle", "warning", "medium", "subtle"],
        "Vertical Garden": ["Advanced", "Small", "$$", "danger", "medium", "subtle", "primary", "medium", "subtle", "warning", "medium", "subtle"],
        "Hydroponic Garden": ["Advanced", "Medium", "$$$", "danger", "medium", "subtle", "accent", "medium", "subtle", "danger", "medium", "subtle"]
    }

    const imageSource = gardenStyles[gardenType] || "./plant.png";
    const description = gardenDescriptions[gardenType];
    const tags = gardenTags[gardenType];

    return (
        <div>
            <div
                className={`garden-style-card ${isSelected ? 'selected' : ''}`}
                onClick={() => onSelect(gardenType)}
            >
                <h3 className="garden-style-card-title">{gardenType}</h3>
                <div className={"garden-style-card-tags"}>
                    <Tag text={tags[0]} type={tags[3]} size={tags[4]} variant={tags[5]}/>
                    <Tag text={tags[1]} type={tags[6]} size={tags[7]} variant={tags[8]}/>
                    <Tag text={tags[2]} type={tags[9]} size={tags[10]} variant={tags[11]}/>
                </div>
                <img className="garden-style-picture" src={imageSource} alt="Garden Type Image"/>
                <p className={"garden-style-card-description"}>{description}</p>
            </div>
        </div>
    );
};

export default GardenStyle;